<template>
  <div class="my-10">
    <div class="flex justify-center px-4 items-center">
      <h1 class="text-3xl font-bold text-center">{{ __('Add user') }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10">
      <div class="max-w-md w-full mx-auto my-10 flex flex-col items-center">
        <form @submit.prevent="submitForm" class="w-full">
          <div>
            <text-input v-model="form.name" :data-error="error('name')" class="w-full pb-8" :label="__('Name')"/>
            <text-input v-model="form.email" :data-error="error('email')" class="w-full pb-8" :label="__('Email')"/>
            <text-input v-model="form.reference_id" :data-error="error('reference_id')" class="w-full pb-8" :label="__('Reference ID')"/>

            <select-input v-model="form.role_id" :data-error="error('role_id')" class="w-full pb-8" :label="__('Role')">
              <option :value="null"/>
              <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
            </select-input>

            <div class="mb-8">
              <label class="block text-gray-400 mb-6">{{ __('Dealerships') }}: </label>
              <div v-for="dealership in dealerships" :key="dealership.id" class="flex items-center mb-4">
                <input v-model="form.dealership_ids" :id="'dealership-' + dealership.id" ref="checkbox" class="border focus:ring focus:border-coral-400" type="checkbox" :value="dealership.id">
                <label class="w-full block text-gray-400 ml-3 text-lg" :for="'dealership-' + dealership.id">
                  {{ dealership.name }}
                </label>
              </div>
            </div>

            <text-input v-model="form.password" :data-error="error('password')" class="w-full pb-8" type="password" :label="__('Password')"/>
            <text-input v-model="form.password_confirmation" :data-error="error('password_confirmation')" class="w-full pb-8" type="password" :label="__('Password confirmation')"/>
          </div>

          <div class="flex flex-col items-center">
            <image-input v-model="form.profileImage" :data-error="error('profileImage')" class="w-full" type="file"/>
          </div>

          <div class="flex justify-center items-center mt-4">
            <loading-button :loading="sendingForm" class="btn-primary" type="submit">{{ __("Save") }}</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import ImageInput from '@/Shared/ImageInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import SelectInput from '@/Shared/SelectInput';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Add user")
      }
    },
    props: {
      roles: Array,
      dealerships: Array,
      dealership_ids: Array,
    },
    data() {
      return {
        form: {
          name: null,
          email: null,
          reference_id: null,
          role_id: null,
          password: null,
          password_confirmation: null,
          profileImage: null,
          dealership_ids: this.dealership_ids
        },
        sendingForm: false,
      }
    },
    components: {
      Layout,
      TextInput,
      ImageInput,
      LoadingButton,
      Icon,
      SelectInput
    },
    methods: {
      submitForm() {
        this.sendingForm = true;
        let data = new FormData();
        data.append('name', this.form.name || '');
        data.append('email', this.form.email || '');
        data.append('reference_id', this.form.reference_id || '');
        data.append('role_id', this.form.role_id || '');
        data.append('password', this.form.password || '');
        data.append('password_confirmation', this.form.password_confirmation || '');
        data.append('profileImage', this.form.profileImage || '');

        this.form.dealership_ids.forEach((id) => {
          data.append('dealership_ids[]', id);
        });

        this.$inertia.post(this.route('users.store'), data)
          .then(() => {
            this.sendingForm = false;
          });
      }
    }
  }
</script>
